import {
  ComponentFactoryResolver,
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import {
  LoadingIndicatorComponent,
  Sizes,
} from './loading-indicator.component';

@Directive({
    selector: '[appLoadingIndicator]',
    standalone: false
})
export class LoadingIndicatorDirective {
  // Template input rename to setIndicatorOptions()
  @Input('appLoadingIndicator')
  // We take in the options specified in the template element
  set setIndicatorOptions(input: LoadingIndicatorOptions) {
    /* Ensure the element the directive is on has a child and if it does delete it,
     it could be either the existing element or the loader indicator comp.
     */
    if (this.vcr.get(0) !== null) {
      this.vcr.remove(0);
    }

    if (input.show) {
      // If we set the show option we add the loading indicator, this is what angular does behind the scenes to create a comp.
      const cmpFactory = this.cfr.resolveComponentFactory(
        LoadingIndicatorComponent,
      );
      const cmp = this.vcr.createComponent(cmpFactory);

      // This allows us to pass in the options we declared for the directive into the component to get the display options.
      cmp.instance.showBackdrop = input.showBackdrop || false;
      cmp.instance.fullPage = input.fullPage || false;
      cmp.instance.size = input.size || Sizes.MEDIUM;
      cmp.instance.message = input.message || '';
      cmp.instance.minHeight = input.minHeight || undefined;
    } else {
      // if we dont show the loader then we create the existing template.
      this.vcr.createEmbeddedView(this.templateRef);
    }
  }

  constructor(
    private vcr: ViewContainerRef,
    private templateRef: TemplateRef<void>,
    private cfr: ComponentFactoryResolver,
  ) {}
}

// If you add new options here you should also bind them into the component above (LoadingIndicatorComponent).
export interface LoadingIndicatorOptions {
  show: boolean;
  showBackdrop?: boolean;
  fullPage?: boolean;
  size?: Sizes;
  message?: string;
  minHeight?: string;
}
